import api from "@/lib/api";
import { toast } from "sonner";

export async function openRazorpay({ order_id, amount, currency, key_id, prefill, description, onSuccess }) {
  if (!window.Razorpay) {
    toast.error("Razorpay लोड नहीं हो सका। पेज रीलोड करें।");
    return;
  }
  return new Promise((resolve) => {
    const rzp = new window.Razorpay({
      key: key_id,
      order_id,
      amount,
      currency,
      name: "INDIAN-NEWS-21",
      description: description || "Payment",
      image: "/logo.png",
      prefill: prefill || {},
      theme: { color: "#0F172A" },
      modal: {
        ondismiss: () => resolve({ dismissed: true }),
      },
      handler: async (res) => {
        try {
          const verify = await api.post("/payments/verify", {
            razorpay_order_id: res.razorpay_order_id,
            razorpay_payment_id: res.razorpay_payment_id,
            razorpay_signature: res.razorpay_signature,
          });
          resolve({ ok: true, data: verify.data });
          if (onSuccess) onSuccess(verify.data);
        } catch (e) {
          toast.error("भुगतान सत्यापित नहीं हो सका");
          resolve({ ok: false, error: e });
        }
      },
    });
    rzp.on("payment.failed", (r) => {
      toast.error("भुगतान असफल: " + (r?.error?.description || "अज्ञात त्रुटि"));
      resolve({ ok: false, error: r });
    });
    rzp.open();
  });
}
